import {AddSchema, CreateAccessor, GetDocs} from "mobx-graphlink";
import {store} from "../../../Store/index.js";
import {DocumentNode, gql} from "@apollo/client";

export class ProcessMessage {
	constructor(data: Partial<ProcessMessage>) {
		Object.assign(this, data);
	}
	//id: string; // same as sendTime.toString(), as below
	/** The account/user-id, used as the channel for communication. (only users signed in as the given user can send/receive on the given channel) */
	userChannel: string;
	/** A string unique to the sender page/"process", identifying it, eg. to determine if a message came from another instance. (NOTE: this id can be guessed/spoofed, so don't use for security) */
	senderProcessId: string;
	/** The message's send-time. (set by the server when it received the message) */
	sendTime: number;
	/** Any json object/value. (in this repo, it is always a channel-message used by the `remoteUserProcessesBridge` Bridge instance however) */
	message: object;
}
AddSchema("ProcessMessage", {
	properties: {
		//id: {type: "string"},
		userChannel: {type: "string"},
		senderProcessId: {type: "number"},
		sendTime: {type: "number"},
		message: {type: "object"},
	},
});

/** This structure is not enforced by the server; it's just the shape that this client package knows-of/expects. */
/*export class ProcessMessageContents {
	requestTTS?: {
		text: string;
		volumeMultiplier?: number;
	};
}*/